// extracted by mini-css-extract-plugin
export default {"statisticGroup":"Statistics_statisticGroup__47R-O"};